module.exports = __webpack_public_path__ + "img/file-code-fill.2e145b7b.svg";